export const breakpoints = {
  mobile: '375px',
  tablet: '768px',
  desktop: '1024px',
  largeDesktop: '1440px'
};
